import styled from 'styled-components';


const Divider = styled.hr`
	width: 100%;
	border: 0;
	border-top: 1px dashed rgba(0,0,0,.19);
	margin: 6px 0 6px 10px;
	background-color: transparent !important;
`;

export {
	Divider,
};
